"use strict";
var calculate_environment_by_host_1 = require("@cian/utils/lib/shared/calculate_environment_by_host");
function declareCianSentryConfiguration(configuration) {
    // tslint:disable-next-line:no-any
    if (!window.Raven) {
        console.warn('Raven is not defined');
        return;
    }
    // tslint:disable-next-line:no-any
    window.Raven.configurations.push(configuration);
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = declareCianSentryConfiguration;
exports.captureException = function (error, options) {
    var fingerprint = ['{{ default }}', calculate_environment_by_host_1.calculateEnvironmentByHost(window.location.host)];
    var exceptionInfo = Object.assign({
        fingerprint: fingerprint,
    }, options);
    if (options && options.fingerprint) {
        exceptionInfo.fingerprint = fingerprint.concat(options.fingerprint);
    }
    // tslint:disable-next-line:no-any
    window.Raven.captureException(error, exceptionInfo);
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@cian/sentry/lib/index.js
// module id = 378
// module chunks = 0